'use client'

import { DMVisibilityTracker } from "@dealermesh/react";

export default function VisibilityPixel(props) {

  if (props.track && props.site.tracking?.indexOf(props.track) < 0) return null;
  
  return <DMVisibilityTracker page={props.site.page_name} name={props.name} data={props.data} minTopValue={0}>
    { props.children || <span style={{ display: 'block', position: 'absolute', width: '1px', height: '1px', padding: 0, margin: 0 }}></span> }
  </DMVisibilityTracker>
  
}